import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {GamesLevelVocabularyComponent} from '../games-level-vocabulary/games-level-vocabulary.component';
import {GamesLevelLessonsComponent} from '../games-level-lessons/games-level-lessons.component';
import {LangSrcService} from '../../../services/lang-src/lang-src.service';
import {GameLevelService} from '../../../services/games/game-level/game-level.service';
import {GameGameService} from '../../../services/games/game-game/game-game.service';
import {PageService} from '../../../services/page/page.service';
import {GameLevelLessonService} from '../../../services/games/game-level-lesson/game-level-lesson.service';
import {MetaService} from '../../../services/meta/meta.service';
import {TranslateService} from '@ngx-translate/core';
import {GamesLevelCulturesComponent} from '../games-level-cultures/games-level-cultures.component';
import {GameLevelCultureService} from '../../../services/games/game-level-culture/game-level-culture.service';
import {GamesLevelsGraphemesComponent} from '../games-levels-graphemes/games-levels-graphemes.component';
import {PlatformService} from '../../../services/platform/platform.service';
import {LangTgtService} from '../../../services/lang-tgt/lang-tgt.service';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {SpinnerComponent} from '../../../components/spinner/spinner.component';
import {GameItemComponent} from '../../../components/games/game-item/game-item.component';
import {SortByPipe} from "../../../pipes/sort-by.pipe";

@Component({
  selector: 'app-games-level',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    SpinnerComponent,
    RouterLink,
    GameItemComponent,
    SortByPipe
  ],
  templateUrl: './games-level.component.html',
  styleUrls: ['./games-level.component.scss']
})
export class GamesLevelComponent implements OnInit, OnDestroy {

  loading = true;
  idSection: string;
  idLevel: string;
  level: any;
  lessons: any;
  cultures: any;
  games: any;

  constructor(
    private route: ActivatedRoute,
    private modal: NgbModal,
    private levelSrc: GameLevelService,
    private gameSrc: GameGameService,
    public langSrcSrv: LangSrcService,
    private router: Router,
    private pageSrv: PageService,
    private levelLessonSrv: GameLevelLessonService,
    private levelCultureSrv: GameLevelCultureService,
    private metaSrv: MetaService,
    private translate: TranslateService,
    public platformSrv: PlatformService,
    public langTgtSrv: LangTgtService
  ) {
  }

  async ngOnInit() {
    this.translate.get(`Chargement...`).subscribe((value: string) => {
      this.metaSrv.setMetas({title: value});
    });
    this.idSection = this.route.snapshot.params.idSection;
    this.idLevel = this.route.snapshot.params.idLevel;
    this.level = await this.levelSrc.findById(this.idLevel);
    if (!this.level) {
      await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'games', this.idSection]);
      return;
    }
    if (this.level.isExam) {
      await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'exam', this.level.uniqid]);
      return;
    }
    this.metaSrv.setMetas({title: this.level.name});
    if (!this.level.locked) {
      this.lessons = await this.levelLessonSrv.findAllByLevel(this.level.uniqid);
      this.cultures = await this.levelCultureSrv.findAllByLevel(this.level.uniqid);
      this.games = await this.gameSrc.findAllByLevel(this.idLevel);
    }
    this.pageSrv.displayPurpleMain = true;
    this.loading = false;
  }

  async ngOnDestroy() {
    this.pageSrv.displayPurpleMain = false;
  }

  async openVocabulary() {
    if (this.level.isGraphemeLevel === true) {
      const modal = this.modal.open(GamesLevelsGraphemesComponent, {
        size: 'lg', centered: true, scrollable: true
      });
      modal.componentInstance.level = this.level;
    } else {
      const modal = this.modal.open(GamesLevelVocabularyComponent, {
        size: 'lg', centered: true, scrollable: true
      });
      modal.componentInstance.level = this.level;
    }
  }

  async openCultures() {
    const modal = this.modal.open(GamesLevelCulturesComponent, {
      size: 'lg', centered: true, scrollable: true
    });
    modal.componentInstance.level = this.level;
    modal.componentInstance.cultures = this.cultures;
  }

  async openLessons() {
    const modal = this.modal.open(GamesLevelLessonsComponent, {
      size: 'lg', centered: true, scrollable: true
    });
    modal.componentInstance.level = this.level;
    modal.componentInstance.lessons = this.lessons;
  }

  async openGame(idGame: string) {
    await this.router.navigate([
      '/',
      this.langSrcSrv.current.shortCode,
      'games',
      this.idSection,
      this.idLevel,
      idGame
    ]);
  }

  trackById(index: number, item: any) { return item.id; }

  getTrainingGames() {
    return this.games.filter(game => !game.checkResult);
  }

  getClassicGames() {
    return this.games.filter(game => game.checkResult);
  }
}
